function ForgotSecurity({ handleSecurityChange, handleSecuritySubmit, securityForm, formErrors }) {

  return (
    <>
      <form onSubmit={handleSecuritySubmit} className="sign-up-form">
        <label className="label-forgot-email">What is your email?</label>
        {securityForm.email ?
          <span className="su-errors">{formErrors.email}</span>
        : null}
        <input 
          className="sign-up-form-input"
          type="text" 
          name="email" 
          placeholder="Email" 
          value={securityForm.email} 
          readOnly
        />

        <label className="label-forgot-email">{securityForm.sec_question}</label>
        {securityForm.email ?
          <span className="su-errors">{formErrors.email}</span>
        : null}
        <input 
          className="sign-up-form-input"
          type="password" 
          name="sec_answer" 
          placeholder="Security Question Answer" 
          onChange={handleSecurityChange} 
          value={securityForm.sec_answer} 
        />      
        
        <button className="sign-up-submit-button" onClick={handleSecuritySubmit}>Submit</button>
      </form>
    </>
  )
}

export default ForgotSecurity
